<template>
  <div>
    <h2>Related Strategies</h2>
    <div class="row">
      <div
        class="col-xs-4"
        v-for="strategy in relatedStrategies"
        :key="strategy.uuid">
        <strategy-image-tile :strategy="strategy"/>
      </div>
    </div>
  </div>
</template>

<script>
import StrategyImageTile from '@/components/strategies/StrategyImageTile'

export default {
  name: 'StrategyRelated',
  components: {
    StrategyImageTile
  },
  props: {
    relatedStrategies: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>
</style>
